import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardService } from "../_services/dashboard.service";
import { Subscription } from "rxjs";
import * as XLSX from "xlsx";
import * as FILESAVER from "file-saver";
import { GlobalService } from "src/app/_services/global.service";
import { TranslateService } from "@ngx-translate/core";
import { ErrorMsgService } from "src/app/shared/error-msg/error-msg.service";
import moment from 'moment';
declare var $: any;

@Component({
  selector: "app-dismissal-process-reports",
  templateUrl: "./dismissal-process-reports.component.html",
  styleUrls: ["./dismissal-process-reports.component.scss"],
})
export class DismissalProcessReportsComponent implements OnInit, OnDestroy {
  loading = false;
  activeTab = "home-tab";
  reportFilter;
  reportFromDate;
  reportToDate;
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  perPage: number = 4;
  tableControls: any = { data: [] };
  averageTableControls: any = { data: [] };
  averageDataArray = [];
  dataArray = [];
  clonedDataArray = [];
  sub;
  printSub;
  currLang;
  constructor(
    private router: Router,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dashboardService: DashboardService,
    private errorMsgService: ErrorMsgService
  ) {
    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.sub = new Subscription();
    this.printSub = new Subscription();
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.printSub.unsubscribe();

    // $("#home-tab").on("click", (e) => {
    //   this.loading = true;
    //   this.activeTab = e.target.id;
    //   this.tabClicked();
    // });
    // $("#profile-tab").on("click", (e) => {
    //   this.loading = true;
    //   this.activeTab = e.target.id;

    //   this.tabClicked();
    // });
    // $("#contact-tab").on("click", (e) => {
    //   this.loading = true;
    //   this.activeTab = e.target.id;
    //   this.tabClicked();
    // });
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe((lng) => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.currentPage = 1;

    let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
      this.loading = false;
      this.currentPage = 1;
      if (res !== null) {
        this.reportFilter = res;
        this.reportToDate = this.reportFilter.toDate;
        this.reportFilter.dismissal
          ? (this.reportFilter.dismissal = JSON.stringify(
            this.reportFilter.dismissal
          ))
          : "";
        this.tabClicked();
        // if (this.reportFilter.clazz != undefined) {
        //   this.activeTab === 'home-tab' ? null :
        //     this.activeTab === 'profile-tab' ?
        //       this.getDismissalStudentsFlowReport() :
        //       this.getDismissalStudentsFlowAverage(this.reportFilter);
        // }
        // else {
        //   this.dataArray = []
        //   this.setTableControls();
        // }

      }
    });
    this.sub.add(x);

    let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
      // if (res && this.router.url.split('/')[2] === 'dismissal-reports' && this.activeTab !== 'home-tab') {
      //   // let workBook = XLSX.utils.book_new();
      //   // workBook.SheetNames.push('test sheet');
      //   // let valuesToBeExported = [];
      //   // let controlType = this.getControlType();
      //   // if (controlType === 'students-log') {
      //   //   valuesToBeExported = this.dataArray.map(data => {
      //   //     return {
      //   //       'name': data['name'],
      //   //       'national_id': data['national_id'],
      //   //       'requested_by': data['requested_by'],
      //   //       'delivered_by': data['delivered_by']
      //   //     }
      //   //   })
      //   // }
      //   // if (controlType === 'average') {
      //   //   valuesToBeExported = this.dataArray.map(data => {
      //   //     return {
      //   //       'national_id': data['national_id'],
      //   //       'name': data['name'],
      //   //       'avg_till_pickup': data['avg_till_pickup'],
      //   //       'avg_till_received': data['avg_till_received'],
      //   //       'avg_full_time': data['avg_full_time'],
      //   //     }
      //   //   })
      //   // }
      //   // let ws_Data = valuesToBeExported;
      //   // let ws = XLSX.utils.json_to_sheet(ws_Data);
      //   // workBook.Sheets['test sheet'] = ws;
      //   // let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');
      //   // function s2ab(s) {
      //   //   let buf = new ArrayBuffer(s.length);
      //   //   let view = new Uint8Array(buf);
      //   //   for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
      //   //   return buf;
      //   // }
      //   // $("#button-a").click(function () {
      //   //   FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
      //   // });
      // }
    });
    this.printSub.add(p);
  }
  tabClicked(tab = this.activeTab) {
    this.activeTab = tab;
    this.activeTab === "home-tab"
      ? null
      : this.activeTab === "profile-tab"
        ? this.getDismissalStudentsFlowReport()
        : this.getDismissalStudentsFlowAverage();
  }
  getDismissalStudentsFlowAverage() {
    this.tableControls = { data: [] };

    this.loading = true;
    this.dashboardService
      .getDismissalStudentsFlowAverage(this.reportFilter, this.currentPage)
      .subscribe((res: any) => {
        this.dataArray = res.data;
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.translate.get("init").subscribe((res) => {
          this.tableFields();
        });
        this.translate.onLangChange.subscribe((res) => {
          this.tableFields();
        });
        this.loading = false;
      });
  }

  tableFields() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: "list",
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total,
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "image_path",
        },
        {
          name: this.translate.instant("dismissal-flowlog.student-name"),
          sort: false,
          type: "string",
          source: "name",
        },
        {
          name: this.translate.instant("dismissal-flowlog.student-id"),
          sort: false,
          type: "string",
          source: "national_id",
        },
        {
          name: this.translate.instant("dismissal-flowlog.avg-till-pickup"),
          sort: false,
          type: "string",
          source: "avg_till_pickup",
        },
        {
          name: this.translate.instant("dismissal-flowlog.avg-till-recieved"),
          sort: false,
          type: "string",
          source: "avg_till_received",
        },
        {
          name: this.translate.instant("dismissal-flowlog.avg-fulltime"),
          sort: false,
          type: "string",
          source: "avg_full_time",
        },
      ],
      data: this.dataArray,
    };
  }
  getDismissalStudentsFlowReport() {
    this.tableControls = { data: [] };

    this.loading = true;
    this.dashboardService
      .getDismissalStudentsFlowReport(this.reportFilter, this.currentPage)
      .subscribe((res: any) => {
        res.data.forEach((element) => {
          element.clazzName = element.class.name;
          element.gradeName = element.class.grade.name;
          element.requested_at !=null ? element.formated_request_at = moment(element.requested_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
          element.delivered_at != null ? element.formated_delivered_at = moment(element.delivered_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
          element.reaction_time !=null ? element.reaction_time :'';
          element.date = element.delivered_at ? moment(element?.delivered_at).format('DD/MM') : element?.requested_at ? moment(element?.requested_at).format('DD/MM'):'';
          // element.formated_request_at = this.formatDate(element.requested_at);
          // element.formated_delivered_at = this.formatDate(element.delivered_at);
          element.originalStatus = element.status_name;
          element.status_name = this.localizeStatus(element.status_name);
          // element.formated_request_at=this.formatDate(element.created_at)
          // element.formated_delivered_at=this.formatDate(element.created_at)
          element?.delivered_to_parent_at != null ? element.formated_delivered_to_parent_at = moment(element?.delivered_to_parent_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
        });
        this.from = res.from;
        this.to = res.to;
        this.total = res.total;
        this.lastPage = res.last_page;
        this.dataArray = res.data;
        this.translate.get("init").subscribe((res) => {
          this.setTableControls();
        });
        this.translate.onLangChange.subscribe((res) => {
          this.currLang = res.lang;
          this.dataArray.forEach((element) => {
            // element.date = element.delivered_at ? moment(element?.delivered_at).locale(this.currLang).format('MM/DD'): moment(element?.requested_at).locale(this.currLang).format('MM/DD')
            element.requested_at !=null ? element.formated_request_at = moment(element.requested_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
            element.delivered_at != null ? element.formated_delivered_at = moment(element.delivered_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
            element.reaction_time !=null ? element.reaction_time:'';
            element?.delivered_to_parent_at != null ? element.formated_delivered_to_parent_at = moment(element?.delivered_to_parent_at).subtract(3,'h').add(localStorage.getItem('timeZoneOffset'),'h').locale(this.currLang).format('hh:mm A'):'';
            element.status_name = this.localizeStatus(element.originalStatus);
          });
          this.setTableControls();
        });
        this.stopLoading();
      });
  }
  setTableControls() {
    this.tableControls = {
      selection: false,
      paging: true,
      view: "list",
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total,
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "image_path",
        },
        {
          name: this.translate.instant("dismissal-flowlog.student-name"),
          sort: false,
          type: "string",
          source: "name",
        },
        {
          name: this.translate.instant("dismissal-flowlog.student-id"),
          sort: false,
          type: "string",
          source: "national_id",
        },
        {
          name: this.translate.instant("dismissal-flowlog.grade"),
          sort: false,
          type: "string",
          source: "gradeName",
        },
        {
          name: this.translate.instant("dismissal-flowlog.class"),
          sort: false,
          type: "string",
          source: `clazzName`,
        },
        {
          name: this.translate.instant("dismissal-flowlog.date"),
          sort: false,
          type: "string",
          source: "date",
        },
        {
          name: this.translate.instant("dismissal-flowlog.request-time"),
          sort: false,
          type: "string",
          source: "formated_request_at",
        },
        {
          name: this.translate.instant("dismissal-flowlog.deliver-time"),
          sort: false,
          type: "string",
          source: "formated_delivered_at",
        },
        {
          name: this.translate.instant("dismissal-flowlog.reaction-time"),
          sort: false,
          type: "string",
          source: "reaction_time",
        },
        {
          name: this.translate.instant("dismissal-flowlog.parent-confirm-time"),
          sort: false,
          type: "string",
          source: "formated_delivered_to_parent_at",
        },
        {
          name: this.translate.instant("dismissal-flowlog.request-by"),
          sort: false,
          type: "string",
          source: "requested_by",
        },
        {
          name: this.translate.instant("dismissal-flowlog.role"),
          sort: false,
          type: "string",
          source: "requested_by_role",
          translateRole: true
        },
        // {
        //   name: this.translate.instant("dismissal-flowlog.delivered-by"),
        //   sort: false,
        //   type: "string",
        //   source: "delivered_by",
        // },
        {
          name: this.translate.instant("dismissal-flowlog.Request-status"),
          sort: false,
          type: "string",
          source: "status_name",
        },
      ],
      data: this.dataArray,
    };
  }
  getControlType() {
    let controlType =
      this.activeTab === "home-tab"
        ? "flow-log"
        : this.activeTab === "profile-tab"
          ? "students-log"
          : "average";
    return controlType;
  }

  stopLoading() {
    this.loading = false;
  }

  back() {
    this.router.navigateByUrl("/reports/dashboard");
  }

  viewStudent(student) {
    if (this.activeTab == "profile-tab") {
      this.dashboardService
        .getStudentDismissalById(student.id, this.reportFilter, 1, this.perPage)
        .subscribe(
          (res) => {
            student["dismissalHistory"] = res;
            student["filter"] = this.reportFilter;
            this.dashboardService.setStudentData(student, "view");
          },
          (err) => {
            this.errorMsgService.setMessage(err.error.message);
          },
          () => {
            $("#viewStudentModal").modal("show");
            this.scrollContentTop("#viewStudentModal");
          }
        );
    }
  }

  // to fix cashed scroll after opening and closing of modal for the same user (view , edit)
  scrollContentTop(modalName) {
    $(`${modalName} .modal-body`)[0].scrollTop = 0;
  }
  paginationHandling(event) {
    this.currentPage += event.dir;
    this.activeTab === "profile-tab"
      ? this.getDismissalStudentsFlowReport()
      : this.getDismissalStudentsFlowAverage();
  }
  tableEventHandeler(event) {
    switch (event.action) {
      case "rowClicked":
        if (this.reportFilter.toDate != this.reportFilter.fromDate) {
          this.viewStudent(event.target.data);
        }

        break;
      // case "iconClicked":
      //   switch (this.listType) {
      //     case "students":
      //       this.editStudent(event.e,event.target.data);
      //       break;
      //       case "parents":
      //         this.editParent(event.e,event.target.data);
      //         break;
      //      }
      // break;
      // case "checkboxChanged":
      //   this.selectChanged(event.target);
      //   break;
      // case "sorting":
      //   this.toggleSorting(event.target.source);
      //   break;
      case "pagination":
        this.paginationHandling(event.target);
        break;
    }
  }

  generateExcelFile() {
    this.dashboardService
      .generateExcelFile(this.reportFilter)
      .subscribe((res) => { });
  }

  exportToExcelFile() {
    let valuesToBeExported = [];
    let title = [];
    if (
      this.reportFilter.toDate == "Invalid date" ||
      this.reportFilter.toDate === this.reportFilter.fromDate
    ) {
      this.reportToDate = "";
    }
    let subTitle = [
      [
        this.reportFilter.grade.name,
        this.reportFilter.clazz.name,
        this.reportFilter.fromDate,
        this.reportToDate,
      ],
    ];
    let fileName = "";
    let workBook = XLSX.utils.book_new();
    let controlType = this.getControlType();
    if (controlType === "students-log") {
      if (this.currLang === "en") {
        fileName = "Dismissal Log.xlsx";
        title = [["Student Dismissal Flow Log"]];
        valuesToBeExported = this.dataArray.map((data) => {
          return {
            "Student Name": data["name"],
            "Student ID": data["national_id"],
            Grade: data["gradeName"],
            Class: data["clazzName"],
            "Request Time": data["formated_request_at"],
            "Deliver Time": data["formated_delivered_at"],
            "Requested By": data["requested_by"],
            Role: data["requested_by_role"],
            "Delivered By": data["delivered_by"],
            "Request status": data["status"],
          };
        });
      } else {
        fileName = "تفاصيل عملية الانصراف.xlsx";
        title = [[" تفاصيل عملية الإنصراف "]];
        valuesToBeExported = this.dataArray.map((data) => {
          return {
            "حالة الطلب": data["status"],
            بإشراف: data["delivered_by"],
            الدور: data["requested_by_role"],
            "طلب بواسطة": data["requested_by"],
            "وقت الإيصال": data["formated_delivered_at"],
            "وقت الطلب": data["formated_request_at"],
            الفصل: data["clazzName"],
            الصف: data["gradeName"],
            " رقم هوية الطالب": data["national_id"],
            "اسم الطالب": data["name"],
          };
        });
      }
    }
    if (controlType === "average") {
      if (this.currLang === "en") {
        fileName = "Dismissal Time.xlsx";
        title = [["Student Average Dismissal time Report"]];
        valuesToBeExported = this.dataArray.map((data) => {
          return {
            name: data["name"],
            national_id: data["national_id"],
            avg_till_pickup: data["avg_till_pickup"],
            avg_till_received: data["avg_till_received"],
            avg_full_time: data["avg_full_time"],
          };
        });
      } else {
        fileName = "تفاصيل وقت الانصراف.xlsx";
        title = [["تفاصيل وقت الإنصراف "]];
        valuesToBeExported = this.dataArray.map((data) => {
          return {
            "متوسط إجمالي مدة الإنصراف": data["avg_full_time"],
            "متوسط المدة من المغادرة حتى تأكيد الاستلام":
              data["avg_till_received"],
            "متوسط المدة من الاستعداد للمغادرة	": data["avg_till_pickup"],
            "رقم هوية الطالب": data["national_id"],
            "	اسم الطالب": data["name"],
          };
        });
      }
    }
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, title, { origin: "K1" });
    XLSX.utils.sheet_add_aoa(ws, subTitle, { origin: "J2" });

    //Starting in the third row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, valuesToBeExported, { origin: "A3" });

    XLSX.utils.book_append_sheet(workBook, ws, "Sheet1");
    let workBookOut = XLSX.writeFile(workBook, fileName);

    function s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    $("#button-a").click(function () {
      FILESAVER.saveAs(
        new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }),
        "test.xlsx"
      );
    });
  }

  formatDate(_date) {
    if (_date != null) {
      let date = new Date(_date);
      let formatedDate = date.toLocaleString("en-GB", {
        hour12: true,

        hour: "2-digit",
        minute: "2-digit",
      });
      formatedDate = formatedDate.replace(",", "");
      return formatedDate.toUpperCase();
    }
  }

   // formatReactionTime(time){
  //   let formatted_time=''
  //   formatted_time = this.currLang == 'en' ? time + 'Minutes': time + 'دقيقة'
  //   return formatted_time
  // }
  localizeStatus(_status) {
    let localizedStatus;

    switch (_status) {
      case "not_requested":
        localizedStatus =
          this.currLang == "en" ? "not requested" : "لم يتم طلبه";
        break;
      case "delivered":
        localizedStatus =
          this.currLang == "en" ? "Delivered" : "تم تسليمه";
        break;
      case "pending":
        localizedStatus = this.currLang == "en" ? "pending" : "قيد الانتظار ";
        break;

      case "with_supervisor":
        localizedStatus =
          this.currLang == "en" ? "with supervisor" : "مع المشرف";
        break;
      case "with_teacher":
        localizedStatus = this.currLang == "en" ? "with teacher" : "مع المعلم";
        break;
      case "with_security":
        localizedStatus = this.currLang == "en" ? "with security" : "مع الحارس";
        break;

      case "with_parent":
        localizedStatus =
          this.currLang == "en" ? "with parent" : "مع ولي الأمر";
        break;
      case "delivered_flow":
        localizedStatus = this.currLang == "en" ? "delivered" : "تم تسليمه";
        break;
      case "pending_flow":
        localizedStatus = this.currLang == "en" ? "pending" : "قيد الانتظار ";
        break;

      case "with_supervisor_flow":
        localizedStatus =
          this.currLang == "en" ? "with supervisor" : "مع المشرف";
        break;
      case "with_teacher_flow":
        localizedStatus = this.currLang == "en" ? "with teacher" : "مع المعلم";
        break;
      case "with_security_flow":
        localizedStatus = this.currLang == "en" ? "with security" : "مع الحارس";
        break;

      case "with_parent_flow":
        localizedStatus =
          this.currLang == "en" ? "with parent" : "مع ولي الأمر";
        break;
      case "delivered_qr":
        localizedStatus =
          this.currLang == "en" ? "delivered QR code" : "QR تم تسليمه كود";
        break;
      case "pending_qr":
        localizedStatus =
          this.currLang == "en" ? "pending QR code" : "QR قيد الانتظار كود";
        break;
      case "with_supervisor_qr":
        localizedStatus =
          this.currLang == "en"
            ? "with supervisor QR code"
            : "QR مع المشرف كود";
        break;
      case "with_teacher_qr":
        localizedStatus =
          this.currLang == "en" ? "with teacher QR code" : "QR مع المعلم كود";
        break;

      case "with_security_qr":
        localizedStatus =
          this.currLang == "en" ? "with security QR code" : "QR مع الحارس كود";
        break;
      case "with_parent_qr":
        localizedStatus =
          this.currLang == "en" ? "with parent QR code" : "QR مع ولى الأمر كود";
        break;
      case "picked_from_school":
        localizedStatus =
          this.currLang == "en" ? "picked from school" : "خرج من المدرسة";
        break;
      case "dropped_at_home":
        localizedStatus = this.currLang == "en" ? "delivered" : "تم تسليمه";
        break;
      case "canceled":
        localizedStatus = this.currLang == "en" ? "canceled" : "تم إلغاؤه";
        break;
      case "Early Dismissal":
        localizedStatus = this.currLang == "en" ? "Early Dismissal" : "إستئذان مبكر";
        break;
    }
    return localizedStatus;
  }
}
